import React, { useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import Div from "@components/Div";
import Label from "@components/Label";
import StyledInputText from "@components/StyledInputText";
import PromptDialog from "@components/PromptDialog";
import { shareOrderReports } from "@app/services/orders/shareOrderReports";
import { useToast } from "@hooks/useToast";
import { Text } from "@components/Text";

const ShareReportPopup = ({orderId, onCancel, onSuccess }) => {
  const { messages } = useIntl();
  const [email, setEmail] = useState("");
  const { showErrorToast } = useToast();

  const handleOnEmailChange = (e) => {
    setEmail(e.target.value);
  }

  const handleShareOrdersReport = async () => {
    try {
      await shareOrderReports(orderId, email);

      onSuccess();

      return;
    } catch {
      showErrorToast(messages.error);
    }
  }

  return (
    <PromptDialog
      title={messages.title_share_reports}
      confirmLabel={messages.button_confirm}
      onCancel={onCancel}
      onConfirm={handleShareOrdersReport}
    >
      <Text textAlign="center">{messages.share_report_description}</Text>

      <Div
        display="flex"
        alignItems="center"
        flexDirection="column"
        textAlign="center"
        mt={3}
        width={1}
      >
        {/* input box */}
        <Div
          mt={2}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <Label mb={2} textAlign="left" width={1}>
            {messages.send_to_email_label}:
          </Label>
          <StyledInputText
            type="text"
            value={email}
            placeholder={messages.label_email}
            onChange={handleOnEmailChange}
            width={1}
            curved
          />
        </Div>
      </Div>
    </PromptDialog>
  );
};
ShareReportPopup.propTypes = {
  orderId: PropTypes.string,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default ShareReportPopup;
